import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M7 21q-.825 0-1.413-.588A1.92 1.92 0 0 1 5 19V6a.97.97 0 0 1-.713-.288A.96.96 0 0 1 4 5q0-.425.288-.713A.96.96 0 0 1 5 4h4q0-.425.288-.713A.96.96 0 0 1 10 3h4q.425 0 .713.288.288.289.287.712h4q.425 0 .713.288.288.289.287.712a.97.97 0 0 1-.288.713A.96.96 0 0 1 19 6v13q0 .825-.588 1.413A1.92 1.92 0 0 1 17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z"
    }, null, -1)
  ]))]))
}
export default { render: render }